
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { 
  Table, 
  TableBody, 
  TableCaption, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { Badge } from "@/components/ui/badge";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

// Import the types from a dedicated types file
import { UserActivityTable } from "@/components/admin/UserActivityTable";

const UsersPage = () => {
  return (
    <ProtectedRoute requiredRole="admin">
      <Navbar />
      <div className="container mx-auto px-4 py-24">
        <Card className="w-full">
          <CardHeader>
            <CardTitle className="text-2xl">User Activity Management</CardTitle>
          </CardHeader>
          <CardContent>
            <UserActivityTable />
          </CardContent>
        </Card>
      </div>
      <Footer />
    </ProtectedRoute>
  );
};

export default UsersPage;
